export interface ExpenseFilters {
  readonly groupId: string;
}

/** Filters live as an OBJECT in the key (not positional) so partial matches are stable. */
export const expenseKeys = {
  all: () => ['expense'] as const,
  lists: () => [...expenseKeys.all(), 'list'] as const,
  list: (filters: ExpenseFilters) => [...expenseKeys.lists(), filters] as const,
  detail: (id: string) => [...expenseKeys.all(), 'detail', id] as const,
  attachment: (id: string) => [...expenseKeys.all(), 'attachment', id] as const,
  groupAttachment: (id: string) => [...expenseKeys.all(), 'group-attachment', id] as const,
} as const;
